import { render } from "./StepOne86_87.vue?vue&type=template&id=50c686c0&scoped=true"
import script from "./StepOne86_87.vue?vue&type=script&lang=js"
export * from "./StepOne86_87.vue?vue&type=script&lang=js"

import "./StepOne86_87.vue?vue&type=style&index=0&id=50c686c0&scoped=true&lang=css"

import exportComponent from "/builds/ser-kso/wz-case-form-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50c686c0"]])

export default __exports__